module.exports = __webpack_public_path__ + "assets/images/1$L.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/1$L.png
// module id = 1272
// module chunks = 1